// @flow
import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { ConfirmationPopover, type Props as ConfirmationProps } from '@ta/social.common-popover';
import { InteractionLogger } from '@ta/tracking.interactions';

// Types for these don't actually matter, only name needs to be specified
type UsedProps = {|
  header: any,
  description: any,
  cancel: any,
  confirm: any,
  onCancel: any,
  onConfirm: any,
|};

type PopoverProps = $Diff<ConfirmationProps, UsedProps>;

type Props = {|
  untagObject?: ?() => void,
  ...PopoverProps,
|};

const UntagConfirmation = ({ untagObject, ...confirmationProps }: Props) => {
  /* You'll no longer be tagged on this post, but the content will still appear on TripAdvisor. */
  const localizationKeys = localize('social_untag_confirmation_message');
  const localizationHeaderKeys = localize('social_untag_yourself'); /* Untag yourself? */
  const cancel = () => localize('aao_delete_cancel_btn_fffff375'); /* Cancel */
  const confirm = () => localize('social_remove_tag'); /* Remove tag */
  return (
    <InteractionLogger>
      {logInteraction => (
        <ConfirmationPopover
          {...confirmationProps}
          header={localizationHeaderKeys}
          description={localizationKeys}
          cancel={cancel}
          confirm={confirm}
          onConfirm={e => {
            logInteraction(e, 'untagConfirm');
            if (untagObject) {
              untagObject();
            }
          }}
          onCancel={e => {
            logInteraction(e, 'untagCancel');
          }}
        />
      )}
    </InteractionLogger>
  );
};

UntagConfirmation.defaultProps = {
  above: undefined,
  below: undefined,
  rightOf: undefined,
  leftOf: undefined,
  alignEdge: undefined,
  shiftX: 0,
  shiftY: 0,
  shiftArrow: 0,
  fixed: false,
  untagObject: null,
};

export default UntagConfirmation;
